export default {
  smStorageLosses: (state) => state.sm_storage_losses,
  smStorageLoss: (state) => state.sm_storage_loss,
};
